import featureImg from '../../Assets/feature-img.png';
import { useTranslation } from 'react-i18next';

const Features = () => {
    const { t } = useTranslation('home');
  return (
    <section className='px-12 py-32 md-max:py-10 md-max:px-6 flex flex-col items-center gap-10'>
        <div className='flex flex-col items-center gap-4'>
            <p className='text-gradient font-medium text-base text-center'>{t('features.miniTitle')}</p>
            <p className='text-[#22272F] font-semibold text-4xl text-center'>{t('features.title')}</p>
        </div>
        <div className='grid grid-cols-2 md-max:grid-cols-1 grid-rows-2 gap-8'>
            <div className='row-span-2 col-span-1 hover:bg-[radial-gradient(51.94%_54.05%_at_50%_52.59%,_#FFFFFF_3.34%,_#72BDFF_100%)] bg-white duration-500 transition-all rounded-[1.4rem] flex flex-col p-7 gap-4'>
                <img src={featureImg} alt="feature" className="object-cover w-full rounded-2xl h-full" />
                <p className='text-[#22272F] text-xl'>{t('features.data.0.title')}</p>
                <p className='text-[#475467] text-lg'>{t('features.data.0.description')}</p>
            </div>

            {t('features.data', { returnObjects: true }).slice(1, 3).map((item) => (
                <div key={item.id} className='row-span-1 hover:bg-[radial-gradient(51.94%_54.05%_at_50%_52.59%,_#FFFFFF_3.34%,_#72BDFF_100%)] duration-500 transition-all bg-white border border-[#ECEFF2] shadow-md rounded-2xl py-10 px-9 flex flex-col gap-4'>
                <img src={item.icon} alt="feature" className="object-cover size-7 rounded-2xl" />
                <p className='text-[#22272F] text-xl'>{item.title}</p>
                <p className='text-[#475467] text-lg'>{item.description}</p>
                {/* <div className='flex group items-center gap-3 cursor-pointer'>
                    <p className='text-gradient font-medium text-base'>{item.buttonText}</p>
                    <FaArrowRight size={16} className='font-normal group-hover:translate-x-4 duration-300' />
                </div> */}
            </div>
            ))}
        </div>
    </section>
  )
}

export default Features